import React from 'react';
import ProgramTypeForm from '../ProgramTypeForm';

import './programTypeEdit.css';

export function ProgramTypeEdit() {
    return <ProgramTypeForm isEdit={true} />;
}
